
import { Progress } from "element-ui"
import { COLLECT_INIT_WIDTH, COLLECT_EXPEND_WIDTH } from "./const.js"
import slotWidget from "./slot-widget"
import redemptionDrawer from "./redemption-drawer"

export default {
  components: {
    [Progress.name]: Progress,
    slotWidget,
    redemptionDrawer
  },
  props: {
    coreData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      drawerSize: COLLECT_INIT_WIDTH
    }
  },
  computed: {},
  watch: {},
  methods: {
    handleOpen() {
      this.$refs.redemptionDrawer.open()
    }
  }
}
